var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_170674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 16.6663H6.66668L15.4167 7.91627C15.8587 7.47424 16.107 6.87472 16.107 6.2496C16.107 5.62448 15.8587 5.02496 15.4167 4.58293C14.9746 4.14091 14.3751 3.89258 13.75 3.89258C13.1249 3.89258 12.5254 4.14091 12.0833 4.58293L3.33334 13.3329V16.6663Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.41699L14.5833 8.75033",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_170674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchLog);
export default __webpack_public_path__ + "static/media/icon_search_log.552583930c16c8a0e0233b2cf7e65d93.svg";
export { ForwardRef as ReactComponent };